<template>
  <div class="currency-select">
    <select
      :value="modelValue"
      @change="$emit('update:modelValue', $event.target.value)"
    >
      <option
        v-for="(currency, index) in $options.currencies"
        :key="index"
        :value="index"
      >{{ currency.symbol + ' ' + currency.code }}</option>
    </select>
  </div>
</template>

<script>
import { currencies } from '@/mainData';

export default {
  name: 'CurrencySelect',

 props: {
    modelValue: {
      type: [Number, String],
      default: 0,
    },
  },

  data() {
    return {
      currencies,
    }
  },

  currencies,
};
</script>

<style lang="sass" scoped>
.currency-select
  width: 104px
  border-radius: 100px
  overflow: hidden
  margin: 0 0 0 8px
  position: relative
  &::after
    content: ''
    border-left: 5px solid transparent
    border-right: 5px solid transparent
    border-top: 5px solid #fff
    width: 0
    height: 0
    top: 50%
    margin: -3px 0 0 0
    right: 16px
    position: absolute
    pointer-events: none
  select
    border: 0
    background: #415E74
    color: #fff
    font-size: 14px
    line-height: 16px
    font-weight: 500
    height: 40px
    width: 100%
    padding: 0 0 0 24px
    cursor: pointer
    appearance: none
    -moz-appearance: none
    -webkit-appearance: none
    &::-ms-expand
      display: none

@media screen and (max-width: 580px)
  .currency-select
    margin: 16px 0 0
</style>

